import React from "react"
import Radium from "higher-order-components/configured-radium"
import { BASE_COPY } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"

const ComponentError = ({ children }) => (
  <div style={style.base}>
    <span style={style.copy}>{children}</span>
  </div>
)

const style = {
  base: {
    background: COLOR_PALETTE.RED,
    display: "inline-block",
    padding: "1em",
    margin: "0.5em"
  },
  copy: {
    ...BASE_COPY,
    color: COLOR_PALETTE.WHITE,
    fontWeight: 600
  }
}

export default Radium(ComponentError)



// WEBPACK FOOTER //
// ./src/components/component-error/index.jsx